// LLM generated - Model Claude 4 Sonnet
import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  LoginHeaderWrapper: {
    display: 'flex',
    alignItems: 'left',
    flexDirection: 'column',
    maxWidth: 420,
    gap: theme.other.spacing._8,
  },
  LoginHeaderWrapperCentered: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    flexDirection: 'column',
    alignSelf: 'stretch',
    minHeight: 126,
    maxWidth: 420,
    gap: theme.other.spacing._8,
    paddingLeft: 0,
    paddingRight: 0,
  },
  LoginHeaderTitle: {
    textTransform: 'uppercase',
  },
  Icon: {
    marginBottom: 0,
  },
  IconCentered: {
    marginBottom: /* eslint-disable-line local-rules/use-theme-tokens */ 20,
  },
  titleSubtitleContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._8,
    textAlign: 'center',
  },
  credentialsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
    alignItems: 'center',
  },
  logosContainer: {
    display: 'flex',
    gap: theme.other.spacing._8,
    alignItems: 'center',
  },
  wrapperWithBottomMargin: {
    marginBottom: theme.other.spacing._40,
  },
  brandBadgesContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: /* eslint-disable-line local-rules/use-theme-tokens */ 20,
  },
}));

export default useStyles;
